export const SITE_URL = 'https://attackyouradventure.com';
export const SITE_NAME = 'ATTACK! Your Adventure';
export const DEFAULT_DESCRIPTION =
  'Get outside with local gear and people who know the area. Rent for your trip, list what you own, or ask a local expert — secure payments on ATTACK! Your Adventure.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;